export const RestFieldsNames = () => ({
  is_deleted: {
    label: "Est archivé",
    keywords: "archivé supprimé deleted",
  },
  assignees: {
    label: "Responsables",
    keywords: "assignees responsables utilisateurs users",
  },
  notes: {
    label: "Notes",
    keywords: "commentaires remarques notes",
  },
  tags: {
    label: "Étiquettes",
    keywords: "catégories mots-clés tags categorie label",
  },
  revisions: { label: "Révision" },
  restored_from: false,
  id: { label: "ID" },
  created_by: { label: "Créé par" },
  created_at: { label: "Date de création" },
  updated_at: { label: "Date de mise à jour" },
  updated_by: {
    label: "Mis à jour par",
    keywords: "updated_by mis à jour par auteur utilisateur user",
  },
  client_id: false,
});
